import { render, staticRenderFns } from "./InputShortAnswer.vue?vue&type=template&id=27218c10&"
import script from "./InputShortAnswer.vue?vue&type=script&lang=js&"
export * from "./InputShortAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports